/** Delay before showing cookie banner so first screen content is visible. */
export const COOKIE_BANNER_SHOW_DELAY_MS = 5000;
